'use client';
import { type MediaResponse } from '@bells/schema/models/media';
import { AspectRatio } from '@radix-ui/react-aspect-ratio';
import React from 'react';
import Image from 'next/image';
import { cn } from '@bells/core/lib/utils';
import { useAppSettings } from '@bells/core';
import { formatBytes } from '@pantajoe/bytes';

const imageTypes: string[] = ['image/png', 'image/jpeg', 'image/webp'];

export const MediaItem = ({
  item,
  selected,
  onSelect,
}: {
  item: MediaResponse;
  selected?: boolean;
  onSelect?: (item: MediaResponse) => void;
}) => {
  const { mediaUrl } = useAppSettings();
  return (
    <div
      className={cn(
        'flex cursor-pointer flex-col gap-2 overflow-hidden rounded-md border border-transparent hover:bg-muted',
        selected ? 'border-2 border-black bg-muted' : undefined
      )}
      onClick={() => {
        if (onSelect) {
          onSelect(item);
        }
      }}
    >
      <div className='grid grid-cols-4 gap-2'>
        <div className='col-span-1'>
          {imageTypes.includes(item.type) && (
            <AspectRatio ratio={4 / 4} className='bg-muted'>
              <Image
                alt={item.originalFileName}
                className='h-full w-full object-cover'
                src={`${mediaUrl}/${item.url}`}
                fill
                unoptimized
              />
            </AspectRatio>
          )}
        </div>
        <div className='col-span-3 flex flex-col'>
          <div className='break-all text-sm font-medium'>
            {item.newFileName}
          </div>
          <div className='text-xs'>{formatBytes(item.size)}</div>
          <div className='text-xs text-muted-foreground'>{item.type}</div>
        </div>
      </div>
    </div>
  );
};
